import React, { useState } from 'react';
import SubmitButton from '../../atoms/submit-button/SubmitButton';

interface SubmitFormProps {
    name: string;
    children: React.ReactNode | React.ReactNode[];
    buttonLabel?: string;
    formMethod?: string;
    formAction?: string;
    actionSlot?: React.ReactNode;
    isActionsCentered?: boolean;
    isInvalid?: boolean;
}

const SubmitForm = ({
    formMethod = "POST",
    formAction,
    buttonLabel,
    name,
    children,
    actionSlot,
    isActionsCentered,
    isInvalid,
}: SubmitFormProps) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const actionsClassNames = isActionsCentered ? 'layout-center layout-grouping-children' : 'layout-grouping layout-pinned';

    return (
        <form method={formMethod} action={formAction} onSubmit={() => setIsDisabled(true)}>
            <div className="layout-grouping-children">
                {children}
                <div className={actionsClassNames}>
                    <SubmitButton
                        name={`${name}-submit`}
                        isdisabled={isInvalid || isDisabled}
                        label={buttonLabel} />
                    {actionSlot && actionSlot}
                </div>
            </div>
        </form>
    );
};

export default SubmitForm;
